import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Fast, searchable dropdown inputs with React",
  "description": "",
  "published": "2016-11-16T00:00:00.000Z",
  "redirect_from": ["/blog/dropdown-inputs-react/swizec/7224"],
  "categories": "Front End, react, Technical",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Input fields that are limited to one of 6,000 possible values… That’s a usability nightmare, right? ?`}</p>
    <p>{`Dump it in a dropdown, and you overwhelm your users. How many even know vanilla dropdowns support search? And besides, you can't style those. Your designer will throw a shit fit. Default browser crap in his beautiful design? No, no, that won't do.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2016/11/vanilla-dropdown.gif",
        "alt": null
      }}></img></p>
    <p>{`Looks vanilla, works vanilla. First open is slow, but search is fast if you know it exists. If you don't, you're screwed.`}</p>
    <p>{`You `}<em parentName="p">{`could`}</em>{` give users an input field and validate against the list of possible entries… no way `}<em parentName="p">{`that's`}</em>{` going to be a nightmare, eh? Is it `}<inlineCode parentName="p">{`stanford`}</inlineCode>{`, `}<inlineCode parentName="p">{`Stanford`}</inlineCode>{`, `}<inlineCode parentName="p">{`stanford university`}</inlineCode>{`, `}<inlineCode parentName="p">{`Stanford university`}</inlineCode>{`, or `}<inlineCode parentName="p">{`Stanford University`}</inlineCode>{`? Some people will enter `}<inlineCode parentName="p">{`stnraofd`}</inlineCode>{`.`}</p>
    <p>{`No, no, the answer is `}<strong parentName="p">{`both`}</strong>{`. You need an input field `}<em parentName="p">{`and`}</em>{` a dropdown. Input filters dropdown, dropdown guides users.`}</p>
    <h2 {...{
      "id": "step-1-react-select"
    }}>{`Step 1: react-select`}</h2>
    <p>{`Jed Watson's `}<a parentName="p" {...{
        "href": "https://github.com/JedWatson/react-select"
      }}>{`react-select`}</a>{` library gives you input fields with dropdowns. Users can use the input field or use the dropdown.`}</p>
    <p>{`Implementation looks like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`import Select from 'react-select';
import 'react-select/dist/react-select.css';

const options = [
    // ...
    { value: 'Stanford University', label: 'Stanford' },
    // ...
];

const field = ({ options }) => (
    <select name="university" value="one" options={options} onchange="{val" ==""> console.log(val)}
    />
);
The <Select> component does everything: input field, styled non-vanilla dropdown, mouse interaction, keyboard shortcuts, filtering. The only gotcha is that options have to be an array of { value, label } objects. Even if both value and label are the same, I tried.A few seconds to render the dropdown. A few seconds to filter. The browser's UI thread blocked, and you can't even see what you're typing.5,258 entries is a lot of entries ?Step 2: react-virtualized-selectBrian Vaughn's react-virtualized-select solves the first problem – opening the dropdown. It's a higher order component that does a thing and then your thing works better.I think it implements paging and hides it behind scroll events. Only a few elements render at a time, and everyone's life is better.Here's how you use it:
import Select from 'react-virtualized-select';
import 'react-select/dist/react-select.css';
import 'react-virtualized/styles.css'
import 'react-virtualized-select/styles.css'const options = [
    // ...
    { value: 'Stanford University', label: 'Stanford' },
    // ...
];const field = ({ options }) => (
    </select> console.log(val)}
    />
);
`}</code></pre>
    <p>{`We changed the `}<inlineCode parentName="p">{`import Select from`}</inlineCode>{` to use `}<inlineCode parentName="p">{`react-virtualized-select`}</inlineCode>{` and… that's all. ?`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2016/11/react-virtualized-select.gif",
        "alt": null
      }}></img></p>
    <p>{`It opens quickly, and I was typing that whole time that nothing was happening. Browser's UI thread still blocking.`}</p>
    <h2 {...{
      "id": "step-3-react-select-fast-filter-options"
    }}>{`Step 3: react-select-fast-filter-options`}</h2>
    <p>{`Brian Vaughn's `}<a parentName="p" {...{
        "href": "https://github.com/bvaughn/react-select-fast-filter-options"
      }}>{`react-select-fast-filter-options`}</a>{` is practically too long to mention in a tweet, and it solves the second problem: fast search.`}</p>
    <p>{`It builds an index of your options and uses advanced computer sciencey algorithms discovered some time in the 60's, probably. We rarely have enough data to worry about actual computer science on the front end, but sometimes we do.`}</p>
    <p>{`Here's how you use it:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`import Select from 'react-virtualized-select';
import createFilterOptions from 'react-select-fast-filter-options';
import 'react-select/dist/react-select.css';
import 'react-virtualized/styles.css'
import 'react-virtualized-select/styles.css'

const options = [
    // ...
    { value: 'Stanford University', label: 'Stanford' },
    // ...
];

const filterOptions = createFilterOptions({ options });

const field = ({ options }) => (
    <select name="university" value="one" options={options} filteroptions={filterOptions} onchange="{val" ==""> console.log(val)}
    />
);
We added a filterOptions prop to Select, which specifies a custom filter implementation, and we used createFilterOptions to instantiate that implementation. No need to worry about how it actually works because It Just Works™.Looks good, works good. Faster even than the vanilla browser implementation ?The only gotcha is that you have to pass the same options to both Select and createFilterOptions. Dynamically generating { value, label } objects from an array won't work.The good news is that the memoization MobX does for @computed values is good enough, so you can do something like this:
class FormData {
    @observable universities = ['Stanford', 'UVA', ...];

    @computed get options() {
        return this.universities.map(name => ({ value: name, label: name }));
    }

    @computed get filterOptions() {
        const options = this.options;
        return createFilterOptions({ options });
    }
}
I don't know if it would work with Redux. As long as you're careful about the reference thing, you should be fine.But is it a good idea?Yes. Use this approach for all select fields. Even the small ones! There's no harm, and it's faster. Winning.</select>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      